// Shared constants for LiveProgressModal
export const CONDITION_OPTIONS = ['EXCELLENT', 'GOOD', 'FAIR', 'POOR', 'NOT_INSPECTED'];
export const REPAIR_TYPES = ['MINOR', 'MAJOR', 'CRITICAL'];
export const CAR_TYPES = ['hatchback', 'sedan', 'suv'];
export const CAR_BRANDS = [
  'Maruti Suzuki', 'Hyundai', 'Tata', 'Mahindra', 'Kia', 'Toyota',
  'Honda', 'Ford', 'Volkswagen', 'Skoda', 'Renault', 'Nissan',
  'MG', 'Jeep', 'BMW', 'Mercedes-Benz', 'Audi', 'Land Rover'
];
export const ACTION_TYPES = [
  { value: 'repair', label: 'Repair' },
  { value: 'replace', label: 'Replace' }
];
export const COMPONENT_DISPLAY_NAMES = {
  'body_panels': 'Body Panels',
  'mechanical': 'Mechanical Parts',
  'electrical': 'Electrical',
  'interior': 'Interior',
  'glass': 'Glass & Mirrors',
  'tyres_wheels': 'Tyres & Wheels',
  'ac_cooling': 'AC & Cooling',
  'exhaust': 'Exhaust System',
  'general_repairs': 'General Repairs',
};
